import { PF_TOKEN_LOCAL_STORAGE_KEY } from '~/constants/local_storage_key'
import { auth } from '~/lib/firebase/auth'
import { proxyLogin } from '~/lib/proxyLogin'
import { getCurrentApiUrls } from '~/lib/api-config'
import { AxiosError } from 'axios'

type Options = {
  refresh: boolean
}

/**
 * toridori-marketing-api（GraphQLサーバー）認証用のトークンを取得する
 * firebase/authで認証済みのトークンを用いてtoridori-marketing-apiのauthエンドポイントを叩き、
 * 帰ってきたBearerトークンをlocalStorageに保存する
 * localStorageに保存されたトークンがある場合はそれを優先的に使う
 * （refreshオプションを指定することで、localStorageに保存されたトークンを破棄する）
 */
export const getPfToken = async (options?: Options) => {
  const { refresh } = options || {}

  if (!refresh) {
    const pfToken = localStorage.getItem(PF_TOKEN_LOCAL_STORAGE_KEY)
    try {
      const { exp } = JSON.parse(atob(pfToken?.split('.')[1] || ''))

      if (exp * 1000 - 1000 > Date.now()) {
        return pfToken
      }
    } catch {
      // pass through
    }
  }
  const marketingToken = await auth.getCurrentIdToken()
  const headers: HeadersInit = {
    'Access-Token': `Bearer ${marketingToken}`,
    Service: 'marketing',
  }
  // supportLoginにidが存在する場合は代理ログインなのでヘッダに情報を追加する
  if (proxyLogin.isProxyLogin()) {
    headers['company-id'] = proxyLogin.getProxyAdvAccountId().toString() || ''
  }

  // 動的API設定を使用
  const backendUrl = getCurrentApiUrls().backend

  const res = await fetch(backendUrl + '/auth', {
    method: 'POST',
    headers,
  })

  if (!res.ok) {
    // 401エラーなどの場合、AxiosError形式でthrow
    const errorData = await res.json().catch(() => ({}))
    const error = new AxiosError('Authentication failed')
    error.response = {
      status: res.status,
      statusText: res.statusText,
      data: errorData,
      headers: {},
      config: {} as any,
    }
    throw error
  }

  const pfTokenBody = await res.json()
  const newPfToken = pfTokenBody.token as string
  if (!newPfToken) throw new Error('authorization failed')
  localStorage.setItem(PF_TOKEN_LOCAL_STORAGE_KEY, newPfToken)
  return newPfToken
}
